var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Route B")]),_c('button',{staticClass:"button",on:{"click":function($event){return _vm.$x5.openModal('route')}}},[_vm._v("Open Modal")])])}
var staticRenderFns = []

export { render, staticRenderFns }